import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useUserNotifications } from "newui/hooks/useUserNotifications";
import { NOTIFICATION_CENTRE_QUERY_KEYS } from "../constants/query-keys";

// C15/D-028: the socket frame is a reference-only PING (no title/body/
// context — Task 111 shipped the pure ping-then-refetch model). AC2's
// "real-time prepend" and AC3's reconnect reconciliation are both satisfied
// by refetching unread-count + the first list page from the 112 API, which
// is the sole source of display text and applies the two-tier redaction
// server-side. This hook never reads a display field off the socket payload.
export const useNotificationCentreLive = (userId: number | undefined, enabled: boolean) => {
	const queryClient = useQueryClient();

	const refetchCentre = useCallback(() => {
		queryClient.invalidateQueries({ queryKey: NOTIFICATION_CENTRE_QUERY_KEYS.unreadCount() });
		queryClient.invalidateQueries({ queryKey: NOTIFICATION_CENTRE_QUERY_KEYS.list() });
	}, [queryClient]);

	useUserNotifications(
		enabled ? userId : undefined,
		refetchCentre, // ping → refetch, payload itself is never rendered
		refetchCentre // reconnect → refetch, closes any missed-event gap
	);
};
